import { useEffect } from 'react';
import { pingPresence } from '../../api/presence';

const VISITOR_ID_KEY = 'rr_visitor_id';
const PING_INTERVAL_MS = 60_000;

let fallbackVisitorId: string | null = null;

const createVisitorId = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, char => {
    const random = (Math.random() * 16) | 0;
    return (char === 'x' ? random : (random & 0x3) | 0x8).toString(16);
  });
};

const getVisitorId = (): string => {
  try {
    const stored = localStorage.getItem(VISITOR_ID_KEY);
    if (stored) return stored;
    const created = createVisitorId();
    localStorage.setItem(VISITOR_ID_KEY, created);
    return created;
  } catch {
    fallbackVisitorId ??= createVisitorId();
    return fallbackVisitorId;
  }
};

/** Пингует BE, пока вкладка видима; ждём загрузку сессии, иначе залогиненный засчитается ещё и гостем. */
export const usePresencePing = (enabled: boolean, sessionKey: string): void => {
  useEffect(() => {
    if (!enabled) return undefined;
    const ping = () => {
      if (document.visibilityState !== 'visible') return;
      pingPresence(getVisitorId()).catch(() => undefined);
    };

    ping();
    const timer = window.setInterval(ping, PING_INTERVAL_MS);
    document.addEventListener('visibilitychange', ping);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', ping);
    };
  }, [enabled, sessionKey]);
};
